import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { VehiclesSelectionComponent } from './components/vehicles-selection/vehicles-selection.component';
import { AuthGuard } from '../../core/guards/auth.guard';


const routes: Routes = [
  {
    path: 'selection',
    component: VehiclesSelectionComponent,
    canActivate: [AuthGuard]
  },
  {
    path: '',
    redirectTo: 'selection',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class VehiclesRoutingModule { }

